"use client";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVerticalIcon } from "lucide-react";

interface AtcViewModeDropdownProps {
  compactView: boolean;
  onCompactViewChange: (compact: boolean) => void;
}

export const AtcViewModeDropdown = ({
  compactView,
  onCompactViewChange,
}: AtcViewModeDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label="Opcje widoku"
          className="h-full w-10"
        >
          <MoreVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onCompactViewChange(false)}
          data-active={!compactView}
          className="data-[active=true]:font-semibold"
        >
          Widok szczegółowy
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onCompactViewChange(true)}
          data-active={compactView}
          className="data-[active=true]:font-semibold"
        >
          Widok uproszczony
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
